import { FC } from 'react';
import { Box, Drawer, DrawerProps, Typography, IconButton } from '@mui/material';
import { ClearOutlined as ClearOutlinedIcon } from '@mui/icons-material';

import Column from '../../../../../components/Column';
import Row from '../../../../../components/Row';
import VerticalDivider from '../../../../../components/Divider/VerticalDivider';

import { Campaign, CampaignAdGroup } from '../../../../../types/Campaign';
import CampaignAdGroupTabPanels from '../Tabs/CampaignAdGroupTabPanels';
import CampaignAdGroupStatus from '../../../../../features/Campaign/CampaignAdGroupStatus';

type CampaignAdGroupDrawerActionCallback = (campaignAdGroup?: CampaignAdGroup) => void;

interface CampaignAdGroupDrawerProps extends DrawerProps {
    campaignAdGroup: CampaignAdGroup;
    campaign: Campaign;
    onCancel?: CampaignAdGroupDrawerActionCallback;
    onSave?: CampaignAdGroupDrawerActionCallback;
}

const CampaignAdGroupDrawer: FC<CampaignAdGroupDrawerProps> = ({
    campaignAdGroup,
    campaign,
    onCancel,
    onSave,
    ...props
}) => {
    return (
        <Drawer
            anchor="right"
            {...props}
            sx={{
                width: 5 / 12,
                flexShrink: 0,
                zIndex: (theme) => theme.zIndex.drawer + 1,

                '& .MuiDrawer-paper': {
                    width: 5 / 12,
                    boxSizing: 'border-box',
                },
            }}
        >
            <Column
                justifyContent="space-between"
                sx={{
                    minHeight: '480px',
                    height: '100%',
                }}
            >
                <Box>
                    <Box
                        component="header"
                        sx={{
                            borderBottom: 1,
                            borderColor: 'divider',
                            paddingX: 3,
                            paddingY: 2,
                        }}
                    >
                        <Row justifyContent="space-between" alignItems="center" spacing={2}>
                            <Row gap={1} alignItems="center">
                                <Typography variant="h6">{campaignAdGroup?.name}</Typography>

                                <VerticalDivider />

                                <CampaignAdGroupStatus value={campaignAdGroup.state || ''} />
                            </Row>

                            <IconButton onClick={() => onCancel?.(campaignAdGroup)} edge="end">
                                <ClearOutlinedIcon fontSize="medium" color="action" />
                            </IconButton>
                        </Row>
                    </Box>

                    <Box>
                        <CampaignAdGroupTabPanels campaignAdGroup={campaignAdGroup} campaign={campaign} />
                    </Box>
                </Box>
            </Column>
        </Drawer>
    );
};

export default CampaignAdGroupDrawer;
